import axios from 'axios';
import BaseAPI from './base/base-api';

class AvaReportAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'avareport';
}

export default new AvaReportAPI();
